<template>
  <!-- 遅延管理 -->
  <div id="ReturnDelayedManagement">
    <div id="container">
      <deviceNavi v-bind:pageid='"ReturnDelayedManagement"'></deviceNavi>
      <div class="labelTitle lable">返却遅延管理</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td>
              <input type="text" v-model="searchCondition.receptionNo"/>
            </td>
            <th>種別</th>
              <td>
                <select v-model="searchCondition.kind">
                  <option v-for="kind of kindList" :value="kind.value" :key="'s' + kind.value">
                    {{kind.label1}}
                  </option>
                </select>
            </td>
            <th>デモ</th>
              <td>
                <select v-model="searchCondition.demo">
                  <option></option>
                  <option value="false">含まない</option>
                  <option value="true">デモのみ</option>
                </select>
              </td>
            <th>機種</th>
              <td>
                <select v-model="searchCondition.devicekind">
                  <option v-for="kind of devicekindList" :value="kind.value" :key="'s' + kind.value">
                    {{kind.kind}}
                  </option>
                </select>
              </td>
          </tr>
          <tr>
            <th>シリアル</th><td><input type="text" v-model="searchCondition.serial" @keyup.enter="onKeyupEnter()"/></td>
            <th>遅延日数</th><td><input type="number" min="1" max="9999" v-model="searchCondition.delayedDays"/></td>
            <th>医療機関<br>/企業</th><td><input type="text" v-model="searchCondition.client"/></td>
            <th>患者名</th><td><input type="text" v-model="searchCondition.patientName"/></td>
          </tr>
          <tr>
            <th>ブロック</th>
              <td>
                <select v-model="searchCondition.block">
                  <option v-for="item in blockMaster" :key="item.code" :value="item.code">{{item.name}}</option>
                </select>
              </td>
            <th>担当支店</th>
              <td>
                <select v-model="searchCondition.branchStore">
                  <option v-for="office of branchOfficeMaster" :value="office.code" :key="'s' + office.code">
                    {{office.name}}
                  </option>
                </select>
              </td>
            <th>営業担当者</th><td><input type="text" v-model="searchCondition.sealsStaff"/></td>
            <th>遅延コール</th>
              <td>
                <select v-model="searchCondition.noticeCall">
                  <option></option>
                  <option value="true">実施済</option>
                  <option value="false">未実施</option>
                </select>
              </td>
          </tr>
          <tr>
            <th>患者コール</th>
              <td>
                <select v-model="searchCondition.noticePatientCall">
                  <option></option>
                  <option value="true">実施済</option>
                  <option value="false">未実施</option>
                </select>
              </td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="data.length > 0">
        <b-button class="clipboadCopyButton is-primary copyButtonStyle" @click="clipboardCopy('returnDelayedManagementTable')">クリップボードにコピー</b-button>
        <span class="result-count">件数：{{data.length}}件</span>
        <b-table
            id="returnDelayedManagementTable"
            :data="data"
            :default-sort="['scheduledReturnDate','asc']"
            sort-icon="arrow-up"
            sort-icon-size="is-small">
            <template slot-scope="props">
              <b-table-column label="#" width="40" centered>{{props.index + 1}}</b-table-column>
              <b-table-column field="receptionNo" label="受付番号" width="120" sortable><a @click="showModal(props.row)">{{props.row.receptionNo}}</a></b-table-column>
              <b-table-column field="kind" label="種別" width="150">{{props.row.kind}}<span v-if="props.row.demoFlag" class="demo"/></b-table-column>
              <b-table-column field="devicekind" label="機種" width="150" sortable >{{props.row.devicekind }}</b-table-column>
              <b-table-column field="serial" label="シリアル" width="100">{{props.row.serial}}</b-table-column>
              <b-table-column field="requestDay" label="出荷日" width="95" centered sortable>{{props.row.requestDay}}</b-table-column>
              <b-table-column field="scheduledReturnDate" label="返却予定日" width="95" centered sortable><span class="red">{{props.row.scheduledReturnDate}}</span></b-table-column>
              <b-table-column field="delayDay" label="遅延日数" width="60" centered><span class="red">{{props.row.delayedDays}}日</span></b-table-column>
              <b-table-column field="patientName" label="患者名" width="130">{{props.row.patientName}}</b-table-column>
              <b-table-column field="client" label="医療機関/企業名" width="210">{{props.row.client}}</b-table-column>
              <b-table-column field="branchStore" label="担当支店" width="130" sortable>{{props.row.branchStore}}</b-table-column>
              <b-table-column field="sealsStaff" label="営業担当者" width="130" sortable>{{props.row.sealsStaff}}</b-table-column>
              <b-table-column field="noticeCall" label="遅延コール" width="90" centered sortable ><span :class="setClass(props.row.noticeCall)">{{props.row.noticeCall}}</span></b-table-column>
              <b-table-column field="noticePatientCall" label="患者コール" width="90" centered sortable ><span :class="setClass(props.row.noticePatientCall)">{{props.row.noticePatientCall}}</span></b-table-column>
            </template>
        </b-table>
      </div>
    </div>
    <b-modal
        :active.sync="returnDelayedDetailModalActive"
        has-modal-card
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Example Modal"
        aria-modal>
        <div class="modal-card" style="width: 650px;">
            <header class="modal-card-head">
                <p class="modal-card-title">遅延情報</p>
            </header>
            <section class="modal-card-body">
                <table class="modalTable">
                    <tr><th>申込み情報</th><td></td></tr>
                    <tr><td>&nbsp;&nbsp;受付番号</td><td>{{selectedData.receptionNo}}</td></tr>
                    <tr><td>&nbsp;&nbsp;申込み日</td><td>{{selectedData.requestDay}}</td></tr>
                    <tr><td>&nbsp;&nbsp;種別</td><td>{{selectedData.kind}}<span v-if="selectedData.demo" class="demo"/></td></tr>
                    <tr><td>&nbsp;&nbsp;機種</td><td>{{selectedData.devicekind}}</td></tr>
                    <tr><td>&nbsp;&nbsp;シリアル</td><td>{{selectedData.serial}}</td></tr>
                    <tr><th>医療機関/企業情報</th><td></td></tr>
                    <tr><td>&nbsp;&nbsp;医療機関/企業名</td><td>{{selectedData.client}}</td></tr>
                    <tr><td>&nbsp;&nbsp;連絡先</td><td>{{selectedData.phoneNumber}}</td></tr>
                    <tr v-if="!selectedData.holterDepoNoticeMail"><th>患者情報</th><td></td></tr>
                    <tr v-if="!selectedData.holterDepoNoticeMail"><td>&nbsp;&nbsp;名前</td><td>{{selectedData.patientName}}</td></tr>
                    <tr v-if="selectedData.patientPoneNumber"><td>&nbsp;&nbsp;連絡先</td><td>{{selectedData.patientPoneNumber}}</td></tr>
                    <tr><th>返却予定日</th><td class="red">{{selectedData.scheduledReturnDate}}</td></tr>
                    <tr><th>遅延日数</th><td class="red">{{selectedData.delayedDays}}日</td></tr>
                    <tr><th>遅延連絡</th><td></td></tr>
                    <tr v-if="!selectedData.holterDepoNoticeMail"><td>&nbsp;&nbsp;遅延メール送付日</td><td>{{selectedData.noticeMail1Date}}(1回目)&nbsp;/&nbsp;&nbsp;{{selectedData.noticeMail5Date}}(2回目)</td></tr>
                    <tr v-if="selectedData.holterDepoNoticeMail"><td>&nbsp;&nbsp;遅延メール送付日</td><td>{{selectedData.holterDepoNoticeMail}}</td></tr>
                    <tr><td>&nbsp;&nbsp;遅延コール(医療機関/企業)</td>
                      <td>
                        <span :class="setClass(selectedData.noticeCall)">{{selectedData.noticeCall}}</span>
                        <b-button class="callButton is-primary" @click="updateCallDate()" icon-left="phone-in-talk-outline"><template v-if="selectedData.noticeCall=='未実施'">連絡済にする</template><template v-else>連絡日を更新する</template></b-button>
                      </td>
                    </tr>
                    <tr v-if="selectedData.patientPoneNumber"><td>&nbsp;&nbsp;患者コール</td>
                      <td>
                        <span :class="setClass(selectedData.noticePatientCall)" style="width:150px;">{{selectedData.noticePatientCall}}</span>
                        <b-button class="callButton is-primary" @click="updatePatientCallDate()" icon-left="phone-in-talk-outline"><template v-if="selectedData.noticePatientCall=='未実施'">連絡済にする</template><template v-else>連絡日を更新する</template></b-button>
                      </td>
                    </tr>
                    <tr><th>担当支店</th><td>{{selectedData.branchStore}}</td></tr>
                    <tr><th>営業担当者</th><td>{{selectedData.sealsStaff}}</td></tr>
                </table>
            </section>
            <footer class="modal-card-foot">
              <div style="margin:auto;">
                <b-button label="閉じる" @click="close" />
                <b-button label="保存" type="is-primary" @click="save"/>
              </div>
            </footer>
        </div>
    </b-modal>
  </div>
</template>

<script>
import {choicesType} from "@/components/mock/base/const.js";
import naviBar from "@/components/mock/philips/device/DeviceNaviBar";

var header = [
'#',
'受付番号',
'種別',
'機種',
'シリアル',
'出荷日',
'返却予定日',
'遅延日数',
'患者名',
'医療機関/企業名',
'担当支店',
'営業担当者',
'遅延コール',
'患者コール',
].join('\t')

export default {
  name: "ReturnDelayedManagement",
  methods: {
    doSearch: function(){
      var isSearchParam = false
      var keys = Object.keys(this.searchCondition)
      for(var i=0; i < keys.length; i++){
        if(this.searchCondition[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }

      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalDeviceManagement.getDelayedReturnDevicesPOST({
            body:_this.searchCondition
          });
        },
        function(result){
          _this.data = result.obj
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    onKeyupEnter: function() {
      if (this.searchCondition.serial) {
        let serialItems = this.searchCondition.serial.split('/');
        if(serialItems.length == 2){
          //　"/"が含まれていたらそれ以降の文字に変更する
          this.searchCondition.serial = serialItems[1]
        }
      }
    },
    showModal: function(item){
      this.selectedData = this.getCopy(item);
      this.returnDelayedDetailModalActive = true;
    },
    save: function() {
      // Web Api Call
      var _this = this;
      var body = {
        id: this.selectedData.id,
        noticeCall: "",
        noticePatientCall: ""
      }
      if (this.selectedData.noticeCall != '未実施') {
        body.noticeCall = this.selectedData.noticeCall
      }

      if (this.selectedData.noticePatientCall != '未実施') {
        body.noticePatientCall = this.selectedData.noticePatientCall
      }

      this.apiCall(
        function(client){
          return client.apis.internalDeviceManagement.setNoticeCallPOST({
            body:body
          });
        },
        function(result){
          var target = _this.data.find(item => {
            return item.id == body.id
          })
          if (target) {
            if (body.noticeCall != "") {
              target.noticeCall = body.noticeCall
            }
            
            if (body.noticePatientCall != "") {
              target.noticePatientCall = body.noticePatientCall
            }
          }

          _this.close();
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    close: function(){
        this.returnDelayedDetailModalActive = false;
    },
    setClass: function(noticDate){
      var ret = "";
      if(noticDate == "未実施"){
        ret = "red"
      }
      return ret;
    },
    updateCallDate: function() {
      this.selectedData.noticeCall = this.yyyy_sla_MM_sla_dd(new Date());
    },
    updatePatientCallDate: function() {
      this.selectedData.noticePatientCall = this.yyyy_sla_MM_sla_dd(new Date());
    },
    getDeviceKinds: async function(){
      // Web Api Call
      var _this = this;
      await this.apiCall(
        function(client){
          return client.apis.internalDeviceManagement.getDeviceKindsPOST({
            body:{}
          });
        },
        function(result){
          var devicekindList = result.obj
          devicekindList = devicekindList.filter(kind => {
            return kind.deleteFlag ? false : true
          })
          devicekindList.unshift({value: ""});
          _this.devicekindList = devicekindList
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    clipboardCopy: function(elementId) {
      console.log(elementId);
      var btable = document.getElementById(elementId);
      var tableWrapper = btable.getElementsByClassName("table-wrapper")[0];
      var table = tableWrapper.getElementsByTagName("table")[0];
      var tbody = table.getElementsByTagName("tbody")[0];
      var tr = tbody.getElementsByTagName("tr")
      var records = []
      for (let i = 0; i < tr.length ;i++) {
        records.push(tr[i].innerText)
      }
      navigator.clipboard
        .writeText(header + '\r\n' + records.join("\n"))
        .then(() => {
          this.showMessage("クリップボードにコピーしました。");
        })
        .catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
    },
  },
  data() {
    let hstList = this.getChoiceList(choicesType.hstKind, true)
    // TODO ホルター実装
    // let holterList = this.getChoiceList(choicesType.holterKind, true)
    let kenshinList = this.getChoiceList(choicesType.kenshinKind, true)
    let holterList = this.getChoiceList(choicesType.holterKind, true)
    var kindList = hstList.concat(kenshinList).concat(holterList)
    kindList = kindList.filter(kind => {
      return kind.deleteFlag ? false : true
    })
    kindList.unshift({value:""});
    var branchOfficeMaster = this.getBranchOfficeMaster();
    branchOfficeMaster.unshift({code:""});
    let blockMaster = this.getBlockMaster();
    blockMaster.unshift({code:""});
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let taskSearchConditions = this.$route.params["taskSearchConditions"];

    return {
      data : [],
      selectedData:{},
      kindList: kindList,
      devicekindList: [],
      blockMaster: blockMaster,
      branchOfficeMaster: branchOfficeMaster,
      returnDelayedDetailModalActive: false,
      searchCondition: {
        receptionNo: "",
        kind: "",
        demo: "",
        devicekind: "",
        serial: "",
        delayedDays: "",
        client: "",
        patientName: "",
        block: "",
        branchStore: "",
        sealsStaff: "",
        noticeCall: "",
        noticePatientCall: "",
      },
      taskSearchConditions: taskSearchConditions,
      userInfo: userInfo
    };
  },
  filters: {},
  components: {
    deviceNavi: naviBar
  },
  mounted: async function() {
    await this.getDeviceKinds();
    if (this.taskSearchConditions) {
      for (const key in this.taskSearchConditions) {
        if(key === "sealsStaff"){
          this.searchCondition[key] = this.userInfo.lastName + " " + this.userInfo.firstName
        } else if (Object.prototype.hasOwnProperty.call(this.searchConditions, key)) {
          this.searchCondition[key] = this.taskSearchConditions[key];
        }
      }
      this.doSearch();
    }
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.tag {
  width :100px;
}
.operation-area {
  width: 1000px;
}
.operation-area::after {
  content: "";
  display: block;
  clear: both;
}
.operationButton {
  width:200px;
}
.modalTable {
  width: 600px;
}
.modalTable th {
  padding-top: 5px;
  font-size: 15px;
}
.red {
    font-weight: bold; 
    color: red;
}
.callButton {
  font-size:12px;
  height: 20px;
  margin-left:50px;
  float:right;
}
.copyButtonStyle {
  position: relative;
  bottom: 6px;
  margin-left: 20px;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/device/ReturnDelayedManagement.vue